import { chakra, Heading, Stack, Text } from "@chakra-ui/react";
import { ProgressBarLocked, ProgressBarUnlocked } from "../progress-stat-card";

export interface ProgressValueBlobProps {
  title: string;
  isPublic?: boolean;
  value: any;
  caption: string;
  progressValue: number;
  onClick?: () => void;
  linkText?: React.ReactNode;
}

export const ProgressValueBlob = ({
  value,
  caption,
  progressValue,
  title,
  isPublic,
  linkText,
  onClick,
}: ProgressValueBlobProps) => {
  return (
    <Stack
      spacing="0"
      alignItems={{
        base: "center",
        md: "flex-end",
      }}
      textAlign={{
        base: "center",
        md: "right",
      }}
    >
      <Text fontSize={11} color="gray.500" fontWeight="medium" pb={1}>
        {caption}
      </Text>
      <Heading as="dd" size="lg" lineHeight="shorter" pb={2} fontWeight="bold">
        {value}
      </Heading>
      {isPublic ? (
        <ProgressBarLocked justifySelf="flex-end" title={title} />
      ) : (
        <ProgressBarUnlocked
          justifySelf="flex-end"
          title={title}
          progressValue={progressValue}
          caption={caption}
          value={value}
        />
      )}
      <chakra.a
        pt={2}
        fontSize="xs"
        apply="styles.mdxStyles.a"
        onClick={onClick}
      >
        {linkText || "How is this calculated?"}
      </chakra.a>
    </Stack>
  );
};
